import { useEffect, useState } from "react";
import {
  IonButton,
  IonButtons,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonPage,
  IonRow,
  IonSearchbar,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from "@ionic/react";
import styles from "./Categories.module.scss";
import { careerZoneSubjects, studentsSubjects, allSubjects } from "../subjects";
import { useRef } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { bookmarkOutline } from "ionicons/icons";
import { getBookmarks } from "../store/Selectors";
import { useStoreState } from "pullstate";
import { BookmarkStore } from "../store";

const Categories = () => {
  const router = useIonRouter();
  const location = useLocation();
  const pageRef = useRef();
  const [subjectCategories, setSubjectCategories] = useState([]);
  const bookmarks = useStoreState(BookmarkStore, getBookmarks);

  useEffect(() => {
    const getSubjects = async (filter) => {
      const subjects =
        filter === "students"
          ? studentsSubjects
          : filter === "career"
          ? careerZoneSubjects
          : allSubjects;
      const tempSubjectCategories = Object.keys(subjects).map((key) => {
        const subjectData = allSubjects[key][0];
        return {
          name: key,
          data: subjectData,
        };
      });
      setSubjectCategories(tempSubjectCategories);
    };

    const params = new URLSearchParams(location.search);
    const q = params.get("q");
    if (q === "students") {
      getSubjects("students");
    } else if (q === "career") {
      getSubjects("career");
    } else {
      getSubjects("all");
    }
  }, [location.search]);

  return (
    <IonPage ref={pageRef}>
      <IonHeader className="ion-no-border">
        <IonToolbar className="ion-no-border">
          <IonTitle
            style={{
              fontSize: "2em",
            }}
          >𝕃𝕠𝕠𝕟ℚ𝕦𝕚𝕫 𝔸+</IonTitle>

          <IonButtons slot="end">
            <IonButton routerLink="/bookmarks">
              <IonIcon icon={bookmarkOutline} />
              &nbsp;
              {bookmarks.length}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className={styles.searchArea}>
          <IonSearchbar
            className="ion-justify-content-center"
            placeholder="Search..."
            onClick={() => router.push("/search")}
          />
        </div>
      <IonGrid>
  <IonRow className={styles.row}>
    {subjectCategories.map((category, index) => {
      const { name, data: subject } = category;
      return (
        <IonCol
          className={styles.col}
          size="12"   // full width (1 item per row)
          key={`subject_${index}`}
        >
          <Link to={`/category/${name}`}>
            <img src={subject.image} alt="cover" />
            <div className={styles.categoryName}>
              <IonCardTitle>{name}</IonCardTitle>
            </div>
          </Link>
        </IonCol>
      );
    })}
  </IonRow>
</IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Categories;

